import { typeSalesFilters } from 'model/dashboardSales/dSalesReducer'
import { typeRequestPagination } from '../system/constants';
import { apiClient } from 'model/axiosConfig';
import { AxiosResponse } from 'axios';


// Type
export type typeSalesRequestFilters = {
    filters: {
        receiptNumber?: string[] | null,
        salePublicId?: string[] | null,
        // paymentType?: string | null,
        payments?: {
            paymentType: string | null,
        }
        id?: string | string[],
        date?: {
            from: string,
            to: string,
        } | {},
        userName?: string | string[] | null,
        store?: {
            name?: string[]
            id?: string
        } | null,
        status?: string | null
    },
    pageFilter?: typeRequestPagination,
    sortFilter: {
        direction: string,
        column: string
    }
}


// Get Sales list
export const getSalesList = async (payload: {
    filters: typeSalesFilters,
    paginationRequest: typeRequestPagination
}) => {

    const path = '/product/sale/search'
    const config = {
        headers: {},
    }

    const data: typeSalesRequestFilters = {
        filters: {},
        pageFilter: payload.paginationRequest,
        sortFilter: {
            direction: 'DESC',
            column: 'date'
        }
    }

    if (payload.filters.storeName || payload.filters.storeId ) {
        data.filters.store = {}

        if (payload.filters.storeName) data.filters.store.name =  [ payload.filters.storeName ]

        if (payload.filters.storeId) data.filters.store.id =  payload.filters.storeId
    }

    if (payload.filters.paymentStatus) data.filters.status! = payload.filters.paymentStatus

    if (payload.filters.salePaymentType) data.filters.payments! = { paymentType: payload.filters.salePaymentType }

    if (payload.filters.date) {
        data.filters.date! = payload.filters.date
    }
    if (payload.filters.cashierName) {
        data.filters.userName! = [ payload.filters.cashierName ]
    }

    if (payload.filters.saleId) {
        data.filters.salePublicId! = [ payload.filters.saleId ]
    }

    if (payload.filters.receiptNumber) {
        data.filters.receiptNumber! = [ payload.filters.receiptNumber ]
    }

    try {
        return await apiClient.post(path, data, config)
    } catch (error) {
        console.log(error)
        return error.response
    }
}


// Get Sale by refund Id list
export const getSalesByRefundId = async (payload: { refundId: string }) => {

    const path = '/product/sale/search'
    const config = {
        headers: {},
    }

    const data = {
        filters: {
            refunds: { id: payload.refundId }
        }
    }
    try {

        return await apiClient.post(path, data, config)
    } catch (error) {
        console.log(error)
        return error.response
    }
}

// Export  Sales list with filters
export const exportSalesListWithFilters = async (payload: {
    filters?: typeSalesFilters, selectedSaleIds?: string[], lang: string
}) => {

    const path = payload.lang ? `/product/sale/export/filter?lang=${ payload.lang }` : `/product/sale/export/filter`
    const config: { headers: {} } = {
        headers: {},
    }

    const data: typeSalesRequestFilters = {
        filters: {},
        sortFilter: {
            direction: 'DESC',
            column: 'date'
        }
    }
    if (payload.filters) {

        if (payload.filters.storeName || payload.filters.storeId ) {
            data.filters.store = {}

            if (payload.filters.storeName) data.filters.store.name =  [ payload.filters.storeName ]

            if (payload.filters.storeId) data.filters.store.id =  payload.filters.storeId
        }

        if (payload.filters.paymentStatus) data.filters.status! = payload.filters.paymentStatus

        if (payload.filters.salePaymentType) data.filters.payments! = { paymentType: payload.filters.salePaymentType }

        if (payload.filters.date) {
            data.filters.date! = payload.filters.date
        }
        if (payload.filters.cashierName) {
            data.filters.userName! = [ payload.filters.cashierName ]
        }

        if (payload.filters.saleId) {
            data.filters.salePublicId! = [ payload.filters.saleId ]
        }

        if (payload.filters.receiptNumber) {
            data.filters.receiptNumber! = [ payload.filters.receiptNumber ]
        }
    }
    if (payload.selectedSaleIds) {data.filters = { id: payload.selectedSaleIds }}

    try {

        return await apiClient.post(path, data, config)
    } catch (error) {
        console.log(error)
        return error.response
    }
}


export type typeSlimSalesRequestFilters = {
    filters: {
        receiptNumber?: string[] | null,
        salePublicId?: string[] | null,
        // paymentType?: string | null,
        payments?: {
            paymentType: string | null,
        }
        id?: string | string[],
        date?: {
            from: string,
            to: string,
        } | {},
        userName?: string | string[] | null,
        store?: {
            name?: string[]
            id?: string
        },
        status?: string | null
    },
    pageFilter?: typeRequestPagination,
    sortFilter: {
        direction: string,
        column: string
    }
}

// Get Sales list
export const slimSalesSearch = async (payload: {
    filters: typeSalesFilters,
    paginationRequest: typeRequestPagination
}) => {

    const path = '/product/sale/slim/search'
    const config = {
        headers: {},
    }

    const data: typeSlimSalesRequestFilters= {
        filters: {},
        pageFilter: payload.paginationRequest,
        sortFilter: {
            direction: 'DESC',
            column: 'date'
        }
    }

    if (payload.filters.storeName || payload.filters.storeId ) {
        data.filters.store = {}

        if (payload.filters.storeName) data.filters.store.name =  [ payload.filters.storeName ]

        if (payload.filters.storeId) data.filters.store.id =  payload.filters.storeId
    }

    if (payload.filters.paymentStatus) data.filters.status! = payload.filters.paymentStatus

    if (payload.filters.salePaymentType) data.filters.payments! = { paymentType: payload.filters.salePaymentType }

    if (payload.filters.date) {
        data.filters.date! = payload.filters.date
    }
    if (payload.filters.cashierName) {
        data.filters.userName! = [ payload.filters.cashierName ]
    }

    if (payload.filters.saleId) {
        data.filters.salePublicId! = [ payload.filters.saleId ]
    }

    if (payload.filters.receiptNumber) {
        data.filters.receiptNumber! = [ payload.filters.receiptNumber ]
    }

    try {
        return await apiClient.post(path, data, config)
    } catch (error) {
        console.log(error)
        return error.response
    }
}



// Get products from sale
export const getProductsFromSale = async (payload: { saleId: string }):Promise<AxiosResponse> => {

    const path = '/product/sale/slim/search/products'
    const config = {
        headers: {},
    }

    const data = {
        filters: {
            saleId: payload.saleId
        },
        sortFilter: {
            direction: 'DESC',
            column: 'name'
        }
    }
    try {

        return await apiClient.post(path, data, config)
    } catch (error) {
        console.log(error)
        return error.response
    }
}


// Get refunds  from sale
export const getRefundsFromSale = async (payload: { saleId: string }):Promise<AxiosResponse> => {

    const path = '/product/refund/search'
    const config = {
        headers: {},
    }

    const data = {
        filters: {
            sale: { id: payload.saleId }
        },
        full: true
    }
    try {

        return await apiClient.post(path, data, config)
    } catch (error) {
        console.log(error)
        return error.response
    }
}
